import { Route, Routes, useLocation, Navigate } from 'react-router-dom';

import './App.css';
import QRCodeSales from './pages/qrCode';
import WatchVideo from './pages/watchVideo';
import Videos from './pages/videos';
import Header from './components/header';
import Footer from './components/footer';
import ScrollToTop from './components/ScrollToTop';

function App() {

  return (
    <div className="App">
      <ScrollToTop/>
      <Header />

        <Routes>
          <Route path="*" element={<h1>Page Not found</h1>} />
          <Route path="/" element={<QRCodeSales />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/watch/:video_name" element={<WatchVideo />} />
        </Routes>

      <Footer />
    </div>
  );
}

export default App;


// in development user following scripts in package.json file:
// "scripts": {
//     "start": "react-scripts --openssl-legacy-provider start",
//     "build": "react-scripts build",
//     "test": "react-scripts test",
//     "eject": "react-scripts eject"
// }

// on production user following scripts in package.json file:
// "scripts": {
//   "start": "NODE_OPTIONS='--openssl-legacy-provider --max_old_space_size=4096' react-scripts start",
//   "build": "NODE_OPTIONS='--openssl-legacy-provider --max_old_space_size=4096' react-scripts build",
//   "test": "react-scripts test",
//   "eject": "react-scripts eject"
// }
